import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, API } from "@/lib/api";
import { Compass, MapPin, Clock, FilePdf } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function SharedBoard() {
  const { shareToken } = useParams();
  const [board, setBoard] = useState(null);

  useEffect(() => {
    api.get(`/shared/boards/${shareToken}`).then((r) => setBoard(r.data)).catch(() => setBoard(false));
  }, [shareToken]);

  if (board === false) return <div className="pt-32 text-center text-muted-foreground">This board doesn't exist.</div>;
  if (!board) return <div className="pt-32 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="pt-24 min-h-screen">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8">
        <div className="flex items-center gap-2 mb-2">
          <Compass size={22} weight="duotone" className="text-[#2E523A]" />
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#4A6E7C]">Shared trip board</span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold">{board.name}</h1>
        {board.description && <p className="text-[#63675E] mt-2 max-w-xl">{board.description}</p>}
        <p className="text-sm text-[#63675E] mt-2 mb-6">Curated by {board.owner_name} · {board.listings?.length || 0} destinations</p>
        <a href={`${API}/shared/boards/${shareToken}/pdf`} target="_blank" rel="noopener noreferrer" className="inline-block mb-8" data-testid="shared-download-pdf">
          <Button variant="outline" className="rounded-full h-11 px-5 border-[#D2D5CD] hover:border-[#2E523A] hover:bg-[#EAEBE6] transition-colors duration-200">
            <FilePdf size={19} weight="duotone" className="text-[#2E523A]" /> Download itinerary PDF
          </Button>
        </a>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="shared-board-grid">
          {board.listings?.map((l, i) => (
            <div key={l.id} className="group overflow-hidden rounded-2xl border border-[#D2D5CD] bg-white animate-fade-up" style={{ animationDelay: `${i * 60}ms` }}>
              <div className="relative h-52 overflow-hidden">
                <img src={l.image} alt={l.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg font-bold">{l.title}</h3>
                <div className="flex items-center gap-3 text-sm text-[#63675E] mt-1">
                  <span className="flex items-center gap-1"><MapPin size={14} /> {l.location}</span>
                  <span className="flex items-center gap-1"><Clock size={14} /> {l.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16 py-10 border-t border-[#D2D5CD]">
          <h3 className="font-display text-2xl font-bold">Plan your own journey</h3>
          <Link to="/"><Button className="rounded-full bg-[#2E523A] hover:bg-[#26442f] mt-4">Explore TravelNext</Button></Link>
        </div>
      </div>
    </div>
  );
}
